<template>
  <div v-html="content" style="background-color: white;padding: 0.2667rem;"></div>
</template>

<script>
import { queryNewsByNewsConfigKey } from "@/api/newApi";
export default {
  data() {
    return {
      content: "",
    };
  },
  created() {
    this.queryNewsByNewsConfigKey();
    show();
  },
  methods: {
    show() {
      document.addEventListener(
        "WeixinJSBridgeReady",
        function onBridgeReady() {
          // 通过下面这个API隐藏底部导航栏
          WeixinJSBridge.call("hideToolbar");
        }
      );
    },

    queryNewsByNewsConfigKey() {
      let param = {
        configKey: 200,
        type: 2,
      };
      queryNewsByNewsConfigKey(param).then((res) => {
        if (res.data) {
          this.content = res.data.content;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
